import React from 'react'
import { Routes, Route } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import Customer from 'pages/Admin/Customer/Table'
import CustomerDetail from 'pages/Admin/Customer/Detail'
import TransactionHistory from 'pages/Admin/TransactionHistory'
import TransactionHistoryDetail from 'pages/Admin/TransactionHistoryDetail'
import DvChat from 'pages/Admin/dvChat'
import QLChatbot from 'pages/Admin/qlChatbot'
import Affiliate from 'pages/Dashboard/Affiliate'
import DanhMucDV from 'pages/Admin/dmdv'
import Login from 'pages/Admin/login'
import AffiliateDetail from 'pages/Dashboard/Affiliate/detail'
import Package from 'pages/Admin/Package/index'
import PackageDetail from 'pages/Admin/Package/detail'
import Service from 'pages/Dashboard/Service'
import ServiceDetail from 'pages/Dashboard/Service/detail'
// import Chats from 'pages/Dashboard/Chats'
// import AiChatBot from 'pages/Dashboard/Chats/AIChat'
// import User from 'pages/Dashboard/User'
// import UserAccount from 'pages/Dashboard/UserAccount'

const App: React.FC = () => {
  return (
    <Routes>
      <Route path='/' element={<Customer />} />
      <Route path='/khach-hang/chi-tiet/:id' element={<CustomerDetail />} />
      <Route path='/lich-su' element={<TransactionHistory />} />
      <Route path='/lich-su/chi-tiet/:id' element={<TransactionHistoryDetail />} />
      <Route path='/dich-vu-chat' element={<DvChat />} />
      <Route path='chatbot' element={<QLChatbot />} />
      <Route path='/doi-tac' element={<Affiliate />} />
      <Route path='/doi-tac/chi-tiet/:id' element={<AffiliateDetail />} />
      <Route path='/danh-muc-dich-vu' element={<DanhMucDV />} />
      <Route path='/login' element={<Login />} />
      <Route path='/goi-dich-vu' element={<Package />} />
      <Route path='/goi-dich-vu/chi-tiet/:id' element={<PackageDetail />} />
      <Route path='/goi-dich-vu/add' element={<PackageDetail />} />
      <Route path='/danh-muc-dich-vu' element={<DanhMucDV />} />
      <Route path='/login' element={<Login />} />
      {/* <Route path='/login' element={<Login />} /> */}
      {/* <Route path='/doi-tac/chi-tiet' element={<AffiliateDetail />} /> */}
      <Route path='/dich-vu' element={<Service />} />
      <Route path='/dich-vu/chi-tiet' element={<ServiceDetail />} />
      {/* <Route path='/ai-chat-bot' element={<AiChatBot />} />
      <Route path='/user' element={<User />} />
      <Route path='/user-account' element={<UserAccount />} /> */}
    </Routes >
  )
}

export default App
